console.log('[HGW] checkout.js loaded');

HGW.checkout = {
  bind() {
    console.log('[HGW] checkout bind running');

    const btn = document.getElementById("hgw-confirm");
    if (!btn || btn.__hgw_bound__) return;

    btn.__hgw_bound__ = true;

    btn.addEventListener("click", async (e) => {
      const t0 = performance.now();
      e.preventDefault();
      e.stopPropagation();

      const ok = HGW.core.validate();
      if (!ok) return;
      console.log("[HGW][perf] validate done:", Math.round(performance.now() - t0), "ms");

      const s = HGW.state.get();
      const d = s.delivery || {};

      /* =====================================
        배송 검증
      ===================================== */

      if (s.method === "delivery") {
        if (d.base_shipping_cost == null) {
          alert("Unable to calculate shipping. Please try again.");
          return;
        }

        if (!d.dispatch_date) {
          alert("Please select a dispatch date.");
          return;
        }

        if (!d.finalized || !d.shipping_variant_id) {
          alert("Shipping has not been finalized yet. Please go back and try again.");
          return;
        }
      }

      try {
        btn.disabled = true;
        window.__HGW_GOING_CHECKOUT__ = true;

        if (HGW.core?.persistProgress) {
          await HGW.core.persistProgress();
        }

        if (HGW.core?.saveCartAttributes) {
          await HGW.core.saveCartAttributes();
        }

        console.log("[HGW][perf] total before redirect:", Math.round(performance.now() - t0), "ms");
        console.log("[HGW] Redirecting to checkout");

        window.location.href = "/checkout";
      } catch (err) {
        console.error("[HGW] checkout failed:", err);
        window.__HGW_GOING_CHECKOUT__ = false;
        btn.disabled = false;
        alert("Unable to save pickup/delivery details. Please try again.");
      }
    });
  }
};

function buildHGWCartAttributes(state) {
  const pickup = state.pickup || {};
  const delivery = state.delivery || {};

  return {
    fulfillment_type: state.method || "",

    pickup_store: state.method === "pickup"
      ? (pickup.store || pickup.store_code || pickup.store_name || "")
      : "",

    pickup_store_code: state.method === "pickup"
      ? (pickup.store_code || pickup.store || "")
      : "",

    pickup_store_name: state.method === "pickup"
      ? (pickup.store_name || pickup.store || "")
      : "",

    pickup_date: state.method === "pickup"
      ? (pickup.date || "")
      : "",

    pickup_time: state.method === "pickup"
      ? (pickup.time || "")
      : "",

    delivery_address: state.method === "delivery"
      ? (delivery.full_address || delivery.address1 || "")
      : "",

    delivery_postcode: state.method === "delivery"
      ? (delivery.postcode || "")
      : "",

    delivery_suburb: state.method === "delivery"
      ? (delivery.suburb || "")
      : "",

    dispatch_date: state.method === "delivery"
      ? (delivery.dispatch_date || "")
      : "",

    signature_required: state.method === "delivery"
      ? (delivery.signature_required ? "yes" : "no")
      : "",

    shipping_cost: state.method === "delivery"
      ? (delivery.final_shipping_cost != null ? String(delivery.final_shipping_cost) : "")
      : ""
  };
}

async function saveHGWCartAttributes() {
  const state = HGW.state.get();
  const attributes = buildHGWCartAttributes(state);

  console.log("[HGW] saving cart attributes", attributes);

  const res = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({ attributes })
  });

  if (!res.ok) {
    throw new Error("Failed to save cart attributes");
  }

  const cart = await res.json();
  console.log("[HGW] cart attributes saved", cart.attributes);
  return cart;
}

function pruneStateAfterCartChange(currentSig) {
  try {
    const cur = HGW.state.get ? HGW.state.get() : {};
    const d = cur.delivery || {};

    let nextState = {
      ...cur,
      step: 2
    };

    if (cur.method === "pickup") {
      nextState = {
        ...cur,
        step: 2,
        date: "",
        time: ""
      };
    }

    if (cur.method === "delivery") {
      nextState = {
        ...cur,
        step: 2,
        delivery: {
          ...d,
          calc_key: "",
          calc_status: "idle",
          calc_error: "",
          is_metro: null,
          area_label: "",
          parcel_count: 0,
          base_shipping_cost: 0,
          final_shipping_cost: 0,
          distance_km: "",
          eta_min: "",
          provider: "",
          policy_agreed: false,
          dispatch_date: "",
          signature_required: false,
          surcharges: {},
          eta_text: "",
          shipping_variant_id: "",
          shipping_cart_sig: "",
          finalized: false
        }
      };
    }

    HGW.state.update(nextState);

    localStorage.setItem(
      "HGW_PICKUP_PROGRESS",
      JSON.stringify({
        ...nextState,
        _ts: Date.now(),
        _cart_sig: currentSig || ""
      })
    );

    return nextState;
  } catch (err) {
    console.warn("[HGW] pruneStateAfterCartChange failed", err);
    return null;
  }
}

async function calculateStepBeforeOpen() {
  try {
    const currentSig = await HGW.core.getCartSignature();

    const raw = localStorage.getItem("HGW_PICKUP_PROGRESS");
    const saved = raw ? JSON.parse(raw) : null;
    const savedSig = saved?._cart_sig || "";

    const cartChanged = !!savedSig && savedSig !== currentSig;

    if (cartChanged) {
      console.log("[HGW] cart changed → prune progress to step2");
      pruneStateAfterCartChange(currentSig);
    }

    const savedStep = HGW.core.restoreProgress
      ? HGW.core.restoreProgress()
      : 1;

    if (savedStep) {
      console.log("[HGW] restore step", savedStep);
      return savedStep;
    }

    return 1;
  } catch (err) {
    console.warn("[HGW] step calculation failed", err);
    return 1;
  }
}

/* ===============================
   HGW Checkout Button Intercept
=============================== */

(function () {
  if (window.__HGW_CUSTOM_CHECKOUT_BOUND__) return;
  window.__HGW_CUSTOM_CHECKOUT_BOUND__ = true;

  document.addEventListener(
    'click',
    async function (e) {
      if (window.__HGW_GOING_CHECKOUT__) return;

      const btn = e.target.closest('#hgw-checkout-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      console.log('[HGW] Custom checkout button clicked');

      if (window.HGW && typeof window.HGW.open === 'function') {
        const step = await calculateStepBeforeOpen();
        console.log("[HGW] opening popup at step", step);
        window.HGW.open(step);
      } else {
        console.warn('[HGW] HGW.open not available');
      }
    },
    true
  );
})();